import WalletsTransactionsPage from './WalletsTransactionsPage.component'

export default WalletsTransactionsPage
